<template>
	<section>
		<main class="container py-12">
			<div class="row">
				<div class="col text-center">


			<div v-if="gender > 0">
						<h2>{{ $t('checkin.form.title') }},<br/><span v-if="gender == 1">{{ $t('booking.bookingtable.tableheader.genders.mrs') }}</span><span v-else>{{ $t('booking.bookingtable.tableheader.genders.mr') }}</span> {{firstname }} {{ lastname }}!</h2>
			<p class="mb-12">{{ $t('checkin.form.subtitle') }}</p>
			</div>
			<div v-else>
			<h2 v-html="$t('checkin.form.title2')"></h2>
			<p class="mb-8">{{ $t('checkin.form.subtitle') }}</p>
			</div>

					<form class="registerform needs-validation" novalidate>
						<div class="row">
							<div class="col text-left mb-2">

								<div class="form-row">
									<div class="form-label-group col-md-3">
										<input v-if="guestExists" type="text" class="form-control" id="datearrival" v-model="$v.arrivalday.$model" readonly="true">
										<input v-else data-height="0"	@focus="show" data-layout="numeric" type="text" class="form-control" id="datearrival" v-model="$v.arrivalday.$model" :class="{ 'form-error': $v.arrivalday.$error }">
										<label for="datearrival">{{ $t('checkin.form.datearrival') }}</label>
									</div>

									<div class="form-label-group col-md-3 select-wrap">
										<input v-if="guestExists" type="text" class="form-control input" id="datedeparture" v-model="$v.departureday.$model" readonly="true">
										<select v-else data-height="0" class="form-control select select-date" id="datedeparture" v-model="$v.departureday.$model" :class="{ 'form-error': $v.departureday.$error }"><option value="" disabled selected>{{ $t('checkin.form.datedeparture') }}</option><option v-for="selDate in datesToSelect">{{selDate}}</option></select>
										<label for="datedeparture" v-if="guestExists">{{ $t('checkin.form.datedeparture') }}</label>
									</div>

									<div v-if="!guestExists" class="form-label-group col-md-1 pt-2 pl-2">
										<a class="info text-left" data-toggle="modal" data-target="#bookingInfo">i</a>
									</div>

									<div class="form-label-group col-md-5 radio-wrap" :class="{ 'form-error': $v.bookingtype.$error }">
										<div class="custom-control pr-5 custom-radio custom-control-inline">
											<input type="radio" id="bookingtype-1" v-model="$v.bookingtype.$model" class="custom-control-input" value="business">
											<label class="custom-control-label" for="bookingtype-1">{{ $t('checkin.form.bookingtypeBusiness') }}</label>
										</div>
										<div class="custom-control custom-radio custom-control-inline">
											<input type="radio" id="bookingtype-2" v-model="$v.bookingtype.$model" class="custom-control-input" value="private">
											<label class="custom-control-label" for="bookingtype-2">{{ $t('checkin.form.bookingtypePrivate') }}</label>
										</div>
									</div>

								</div>

								<div class="form-row">
					<div class="form-label-group col-md-1 select-wrap">
					<select data-height="0" class="form-control select select-date" id="gender" v-model="$v.tmpGender.$model" :class="{ 'form-error': $v.tmpGender.$error }"><option value="" disabled selected>{{ $t('checkin.form.gender.selector') }}</option><option value="1">{{ $t('checkin.form.gender.mrs') }}</option><option value="2">{{ $t('checkin.form.gender.mr') }}</option></select>
					</div>
									<div class="form-label-group col-md-3">
										<input type="text"@focus="show" data-height="50" data-layout="compact" class="form-control" :class="{ 'form-error': $v.firstname.$error }" v-model="$v.firstname.$model" id="vorname" required>
										<label for="vorname">{{ $t('checkin.form.vorname') }}</label>
									</div>
									<div class="form-label-group col-md-3">
										<input type="text" class="form-control" @focus="show" data-height="50" data-layout="compact" :class="{ 'form-error': $v.lastname.$error }" v-model="$v.lastname.$model" id="nachname" required>
										<label for="nachname">{{ $t('checkin.form.nachname') }}</label>
									</div>
									<div class="form-label-group col-md-2">
										<input type="text" class="form-control" id="datebirthday" data-height="50" @focus="show" data-layout="numeric" :class="{ 'form-error': $v.birthday.$error }" v-model="$v.birthday.$model" required>
										<label for="datebirthday">{{ $t('checkin.form.datebirthday') }}</label>
									</div>
					<div class="form-label-group col-md-3">
										<input type="text" class="form-control" @focus="show" data-height="50" data-layout="compact" :class="{ 'form-error': $v.company.$error }" v-model="$v.company.$model" id="firma" required>
										<label for="firma">{{ $t('checkin.form.company') }}</label>
									</div>
								</div>

								<div class="form-row mb-4">
					<div class="form-label-group col-md-2">
										<input type="text" class="form-control" @focus="show" data-height="50" data-layout="compact" :class="{ 'form-error': $v.nationality.$error }" v-model="$v.nationality.$model" id="staatsangehoerigkeit" required>
										<label for="staatsangehoerigkeit">{{ $t('checkin.form.staatsangehoerigkeit') }}</label>
									</div>
									<div class="form-label-group col-md-3">
										<input type="text" class="form-control" @focus="show" data-height="-100" data-layout="compact" :class="{ 'form-error': $v.streetandnumber.$error }" v-model="$v.streetandnumber.$model" id="strasse" required>
										<label for="strasse">{{ $t('checkin.form.strasse') }}</label>
									</div>
									<div class="form-label-group col-md-1">
										<input type="text" class="form-control" @focus="show" data-height="-100" data-layout="compact" :class="{ 'form-error': $v.zip.$error }" v-model="$v.zip.$model" id="postleitzahl" required>
										<label for="postleitzahl">{{ $t('checkin.form.postleitzahl') }}</label>
									</div>
									<div class="form-label-group col-md-3">
										<input type="text" class="form-control" @focus="show" data-height="-100" data-layout="compact" :class="{ 'form-error': $v.city.$error }" v-model="$v.city.$model" id="wohnort" required>
										<label for="wohnort">{{ $t('checkin.form.wohnort') }}</label>
									</div>
									<div class="form-label-group col-md-3">
										<input type="text" class="form-control" @focus="show" data-height="-100" data-layout="compact" :class="{ 'form-error': $v.country.$error }" v-model="$v.country.$model" id="staat" required>
										<label for="staat">{{ $t('checkin.form.staat') }}</label>
									</div>
								</div>

								<p>{{ $t('checkin.form.additionalinfos') }}:</p>
								<div class="form-row mb-4">
									<div class="form-label-group col-md-4">
										<input type="text" class="form-control" data-height="-350" @focus="show" data-layout="compact" v-model="licenseplate" id="autokennzeichen">
										<label for="autokennzeichen">{{ $t('checkin.form.autokennzeichen') }}</label>
									</div>
									<div class="form-label-group col-md-4">
										<input type="text" class="form-control" data-height="-350" @focus="show" data-layout="compact" v-model="mobilephone" id="handynummer">
										<label for="handynummer">{{ $t('checkin.form.handynummer') }}</label>
									</div>
									<div class="form-label-group col-md-4">
										<input type="email" class="form-control" data-height="-350" @focus="show" data-layout="compact" :class="{ 'form-error': $v.emailaddress.$error }" v-model="$v.emailaddress.$model" id="emailadresse" required>
										<label for="emailadresse">{{ $t('checkin.form.emailadresse') }}</label>
									</div>
								</div>

								<p>{{ $t('checkin.form.unterschrift') }}:</p>
								<div class="form-row">
									<div class="form-label-group col-md-6">
										<div v-if="false">
											<input type="text" class="form-control unterschrift" id="unterschrift">
											<label for="unterschrift">{{ $t('checkin.form.unterschrift') }}</label>
										</div>
										<SignaturePad
												class="p-0"
												:class="{ 'form-error': $v.signature.$error }"
												id="signature"
												ref="signaturePad"
										/>
									</div>
									<div class="form-label-group col-md-4 align-self-end">
										<button @click.prevent="clearSignature" class="btn btn-primary btn-clear">{{ $t('checkin.form.unterschriftloeschen') }}</button>
									</div>
								</div>
							</div>
						</div>

						<div class="row pt-3">
							<div class="col-md-3 text-left">
								<a @click.prevent="lastStep" class="btn btn-secondary btn-prev">{{ $t('checkin.cancel') }}</a>
							</div>
							<div class="col-md-6 pt-3 dots">
								<p><span class="dot"></span> <span class="dot active"></span> <span class="dot"></span></p>
							</div>
							<div class="col-md-3 text-right">
								<button @click.prevent="nextStep" class="btn btn-primary btn-next" type="submit">{{ $t('checkin.next') }}</button>
							</div>
						</div>
					</form>
				</div>
			</div>

		<div id="bookingInfo" class="modal fade" role="dialog" aria-labelledby="bookingInfo">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Info</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p v-html="$t('checkin.form.subtitle2')"></p>
			</div>
			</div>
		</div>
		</div>

		</main>
	</section>
</template>

<script>
	import axios from 'axios'
	import SignaturePad from 'vue-signature-pad'
	import moment from 'moment'
	import VueI18n from 'vue-i18n'

	import { validationMixin } from 'vuelidate'
	import { required, minLength, between, email } from 'vuelidate/lib/validators'
	import { mapState } from 'vuex';

	export default {
		mixins: [validationMixin],
		validations: {
		arrivalday: {
			required
		},
		departureday: {
			required
		},
		bookingtype: {
			required
		},
		tmpGender: {
			required
		},
			firstname: {
				required
			},
			lastname: {
				required
			},
			birthday: {
				required
		},

		company: {
		},

			nationality: {
				required
			},
			streetandnumber: {
				required
			},
			zip: {
				required
			},
			city: {
				required
			},
			country: {
				required
			},
			emailaddress: {
				required,
				email
			},
			signature: {
				required
			}
		},
		props: [],
		computed: {
			...mapState('settings', ['config']),
		},
		data: function () {
			return {

				height1: 100,
				height2: 50,
				height3: 0,
				height4: -50,
				height5: -100,
				hegiht6: -150,
				height7: -200,

				guestBirthday: null,
						showError: false,

				/* guest data */
				gender: this.$parent.guest.gender,
				tmpGender: null,
				firstname: this.$parent.guest.firstname,
				lastname: this.$parent.guest.lastname,
				arrivalday: this.dateFormat(this.$parent.guest.arrivalDay),
				departureday: this.dateFormat(this.$parent.guest.departureDay),
				birthday: this.dateFormat(this.$parent.guest.birthday),
				company: this.$parent.guest.company,
				nationality: null,
				streetandnumber: null,
				zip: this.$parent.guest.zip,
				city: this.$parent.guest.city,
				country: null,
				signature: null,
				guestExists: this.$parent.guest.guestExists,
				bookingtype: null,

				/* additional Data */

				licenseplate: null,
				mobilephone: null,
				emailaddress: null,

/*
				spousefirstname: null,
				childrenscount: null,
				travelOrganisationCount: null
*/
				datesToSelect: null
			}
		},
		created: function() {
			// this.$v.$touch();

		if(!this.guestExists) {
			var currentDay = new Date();
			this.arrivalday = this.dateFormat(currentDay);
		}

		var tomorrowDate = new Date();
		tomorrowDate.setDate(tomorrowDate.getDate() + 1);

		var tomorrowDay = this.dateFormat(tomorrowDate);

		this.datesToSelect= [
			this.arrivalday,
			tomorrowDay
		];
			this.$parent.direction = true;

		this.tmpGender = this.$parent.guest.gender;
		},
		methods: {

			lastStep() {
				this.$parent.hide();
				this.$parent.direction = false;

				if(this.guestExists) {
					this.$parent.component = 'CheckinLogin';
				} else {
				this.$parent.component = 'CheckinCreditCard';
				}
			},
			nextStep() {
				this.$parent.visible = false;
				this.$parent.fieldHeightText = 'transform:translateY(0)';

				this.signature = this.$refs.signaturePad.saveSignature();

				this.signature = this.signature.data;
				if(this.signature === "undefined") {
					this.signature = null;
				}

				this.$v.$touch();

				if (this.$v.$invalid) {
					return false;
				}
				// console.log(this.$parent.guest);

				var _guest = this.$parent.guest;

				_guest.tmpGender = this.tmpGender;
				_guest.arrivalday = this.arrivalday;
				_guest.departureday = this.departureday;
				_guest.bookingtype = this.bookingtype;
				_guest.birthday = this.birthday;
				_guest.bookingday = this.dateFormat(this.$parent.guest.bookingDay);
				_guest.firstname = this.firstname;
				_guest.lastname = this.lastname;
				_guest.street = this.streetandnumber;
				_guest.zip = this.zip;
				_guest.city = this.city;
				_guest.country = this.country;
				_guest.nationality = this.nationality;

				_guest.licenseplate = this.licenseplate;
				_guest.mobilephone = this.mobilephone;
				_guest.emailaddress = this.emailaddress;

				var currentsignature = this.$refs.signaturePad.saveSignature();
				_guest.signature = currentsignature.data;

				if(this.$parent.guest.roomCategory.price) {
					_guest.roomCategory.price = this.$parent.guest.roomCategory.price;

					//TODO: Hier später je nach kategorie anpassen, wenn für jeden Zimmer-Typ eine eigene Kategorie existiert
					_guest.roomCategory.description = 'Einzelzimmer/Doppelzimmer';
					
					if(_guest.roomCategory.code) {
						_guest.roomCategory.code = _guest.roomCategoryConfig.overrideCode || _guest.roomCategory.code;
					}
				}

				this.$parent.guest = _guest;

				let formGuest = JSON.stringify(_guest);

				let formData = new FormData();
				formData.append('checkin', formGuest);

				axios({
					method: 'post',
					url: this.config.apiUrl + 'saveCheckin',
					withCredentials: true,
					data: formData
				}).then(response => (
					// console.log(['Response Data - roomNumber',response.data.returnValue.roomNumber]),
					// console.log(['PARENT GUEST', this.$parent.guest]),

					this.$parent.guest.roomNumber = response.data.returnValue.roomNumber,
					this.$parent.guest.keyBoyCode = response.data.returnValue.keyBoyCode,

						// console.log("Formdata send"),
					this.$parent.component = 'CheckInFinish'
				))
			},

			clearSignature() {
				// this.$refs.signaturePad.undoSignature();
				this.$refs.signaturePad.clearSignature();
			},
			saveSignature() {
					const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			},
			dateFormat(value) {
				if (value) {
				return moment(String(value)).format('DD.MM.YYYY') != 'Invalid date' ? moment(String(value)).format('DD.MM.YYYY') : value;
				}
			},

			/** Keyboard Events **/
			accept(text) {
				this.$parent.accept(text);
			},
			show(e) {
				this.$parent.show(e);
			},

			hide() {
				this.$parent.hide();
			},

			next() {
				this.$parent.next();
			}

		},
		components: {
			SignaturePad
		}
	}
</script>

<style scoped lang="scss">

	.radio-wrap {
		padding: 10px 0 10px 60px;
		&.form-error {
			border: 2px solid red;
			background: #eecccc !important;
			color: #000;
		}
		input:not(:placeholder-shown) ~ label {
			font-size: 1.3rem;
		}
		.custom-control-label {
			&:before {
				width: 1.4rem;
				height: 1.4rem;
				top: .45rem;
				left: -2rem;
			}
			&:after {
				top: 0.15rem;
				left: -2.3rem;
				width: 2rem;
				height: 2rem;
				content: "";
			}
		}
		.custom-control-input:checked ~ .custom-control-label {
			&:before {
				background-color: #b29348;
				border-color: #b29348;
			}
			&:after {
				background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23000'/%3e%3c/svg%3e");
			}
		}
	}

	#signature.form-error,
	input.form-error,
	select.form-error {
		border: 2px solid red;
	background: #eecccc !important;
	}

	div {
	.form-error {
		canvas {
		background-color: #eecccc;
		}
	}
	}



	select {

	&.select-date {
		background: -webkit-gradient(linear,left top,right top,from(#989fa4),color-stop(#c8d3d9),to(#989fa4));
		background: linear-gradient(90deg,#989fa4,#c8d3d9,#989fa4);
		// -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.25);
		// box-shadow: 0 5px 10px rgba(0,0,0,.25);
	}
	}


	h5.modal-title {
	background: none;
	color: black;
	-webkit-text-fill-color: black;
	}

	.modal-body {
	color: black;
	}

	.info {
	right: 1rem;
	bottom: 1rem;
	background-image: linear-gradient(135deg,#989fa4,#c8d3d9,#989fa4);
	width: 2.5rem;
	height: 2.5rem;
	color: #000 !important;
	font-weight: bold;
	border-radius: 100%;
	padding-top: .5rem;
	font-size: 1.25rem;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	padding-left: 1.1rem;
	&:hover,
	&:focus,
	&:active {
		color: #000;
	}
	}

</style>
